'use strict';

$(document).ready(function () {
    $('.account-link').on('click', function (e) {
        e.preventDefault();
        if ($('#customer-authenticated').val() !== 'true') {
            $('#loginPopupModal').modal('show');
        } else {
            window.location.assign($(this).attr('href'));
        }
    });
    $('body').on('input keyup', '#registration-form #full-name, #editProfileInfo #firstName, #editProfileInfo #occupation', function () {
        $(this).val($(this).val().replace(/[^a-zA-Z\s]/g, '').trimStart());
    });
    $('body').on('input', '#registration-form #email, #editProfileInfo #email', function () {
        var val = $(this).val().replace(/[^a-zA-Z0-9@._+\-\s]/g, '').trimStart();
        val = val.substring(0, 80);
        $(this).val(val);
    });
    // Prevent multiple spaces for inputs with .py-floating-input class
    $('.py-floating-input').on('input', function () {
        var enteredValue = $(this).val().replace(/\s{2,}/g, ' ');
        $(this).val(enteredValue);
    });
});

/** Attaches click handler to open login modal and fetch content via AJAX.
 * @param {string} button - jQuery selector for the button. */
function openLoginSignupModal(button) {
    $(button).click(function () {
        var url = $(this).data('url');
        $.spinner().start();

        $.ajax({
            url: url,
            method: 'GET',
            success: function (response) {
                if (response && response.success === true) {
                    $('#loginPopupModal').modal('show');
                }
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });
}

module.exports = {
    openLoginSignupModal: openLoginSignupModal
};
